import { ALL_CHART_TYPES } from "constants/chart.constants";

/**
 * Get chart-type key for given id.
 *
 * @param {string} id id of chart-type
 * @returns {string} chart type key
 */
const getChartTypeLabelFromId = (id: number): string => {
  const chartType = Object.values(ALL_CHART_TYPES).find(
    (chartType) => chartType.id === id
  );

  if (!chartType) {
    throw "invalid label provided";
  }

  return chartType.label;
};

export default getChartTypeLabelFromId;
